import type { ColDef, ICellRendererParams } from "ag-grid-community";
import React from "react";
import {
	RecipientTypeChips,
	getRecipientText,
} from "../../../emailTopics/components/RecipientTypeChips";
import type { EmailAddress } from "../../../emailTopics/models/EmailAddress";
import { ButtonsCellRenderer } from "./ButtonsCellRenderer";

const getTopicsByType = (address?: EmailAddress) => ({
	TO: address?.TopicsTO,
	CC: address?.TopicsCC,
	BCC: address?.TopicsBCC,
});

type Props = {
	editEmailAddress: (address: EmailAddress) => void;
	deleteEmailAddress: (address: EmailAddress) => void;
	showContextMenu: (
		event: React.MouseEvent,
		data: EmailAddress,
		configId: string,
	) => void;
};

export const useTableEmailAddresses = ({
	editEmailAddress,
	deleteEmailAddress,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "Address",
			headerName: "Address",
			flex: 1.5,
			minWidth: 20,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "flex-start",
			},
		},
		{
			field: "Topics",
			headerName: "Topics",
			flex: 3,
			minWidth: 20,
			wrapText: true,
			autoHeight: true,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "flex-start",
			},
			valueGetter: ({ data }) => getRecipientText(getTopicsByType(data), 15),
			cellRenderer: ({ data }: ICellRendererParams<EmailAddress>) => (
				<RecipientTypeChips values={getTopicsByType(data)} maxVisible={15} />
			),
		},
		{
			headerName: "",
			field: "-",
			cellRenderer: ButtonsCellRenderer,
			cellRendererParams: {
				editEmailAddress,
				deleteEmailAddress,
				showContextMenu,
			},
			sortable: false,
			filter: false,
			flex: 1,
			minWidth: 200,
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			autoHeaderHeight: true,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
	];

	return { columnDefs };
};
